import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../styles/theme';

const PaymentCancel = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
      fontFamily: theme.typography.fontFamily,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
    },
    content: {
      maxWidth: '600px',
      textAlign: 'center',
      backgroundColor: theme.colors.surface,
      padding: '60px 40px',
      borderRadius: theme.borderRadius.lg,
      border: `2px solid ${theme.colors.borderDark}`,
      boxShadow: theme.shadows.lg,
    },
    icon: {
      fontSize: '4rem',
      marginBottom: '20px',
      color: theme.colors.warning || '#f59e0b',
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: theme.colors.text,
      marginBottom: '15px',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    subtitle: {
      fontSize: '1.2rem',
      color: theme.colors.textLight,
      marginBottom: '20px',
      fontWeight: '600',
    },
    description: {
      fontSize: '1rem',
      color: theme.colors.textLight,
      lineHeight: '1.6',
      marginBottom: '40px',
    },
    buttonGroup: {
      display: 'flex',
      gap: '15px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    primaryButton: {
      backgroundColor: theme.colors.primary,
      color: '#fff',
      border: `2px solid ${theme.colors.primary}`,
      borderRadius: theme.borderRadius.sm,
      padding: '12px 24px',
      fontSize: '0.9rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: theme.colors.text,
      border: `2px solid ${theme.colors.border}`,
      borderRadius: theme.borderRadius.sm,
      padding: '12px 24px',
      fontSize: '0.9rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
    supportSection: {
      backgroundColor: theme.colors.backgroundLight,
      padding: '20px',
      borderRadius: theme.borderRadius.md,
      marginTop: '30px',
      textAlign: 'left',
    },
    supportTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: theme.colors.text,
      marginBottom: '10px',
    },
    supportText: {
      fontSize: '0.9rem',
      color: theme.colors.textLight,
      lineHeight: '1.5',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>⚠️</div>
        
        <h1 style={styles.title}>Payment Canceled</h1>
        
        <p style={styles.subtitle}>
          No worries! Your payment was not processed.
        </p>
        
        <p style={styles.description}>
          You can continue using ByteBot with your current plan, or try upgrading again 
          whenever you're ready. Your account and all your chatbots remain active.
        </p>

        <div style={styles.buttonGroup}>
          <Link 
            to="/dashboard/subscription" 
            style={styles.primaryButton}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = theme.colors.primaryDark;
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = theme.colors.primary;
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Try Again
          </Link>
          
          <Link 
            to="/dashboard" 
            style={styles.secondaryButton}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = theme.colors.backgroundLight;
              e.target.style.borderColor = theme.colors.primary;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = theme.colors.border;
            }}
          >
            Back to Dashboard
          </Link>
        </div>

        <div style={styles.supportSection}>
          <h3 style={styles.supportTitle}>Need Help?</h3>
          <p style={styles.supportText}>
            If you experienced any issues during checkout or have questions about our plans, 
            our support team is here to help. Contact us at <strong>support@bytebot.ai</strong> 
            and we'll get back to you within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel; 